import { useSubscription } from '@apollo/client/react'
import { GlobalProviderDashboardWarningNotifierSubscriptionDocument } from '@docpace/manager-graphql/dist/urql.types'
import { GlobalProviderDashboardWarningNotifierSubscriptionResultFragment } from '@docpace/manager-graphql'

export function useGlobalProviderDashboardWarningNotifierSubscription(opts: useSubscription.Options<GlobalProviderDashboardWarningNotifierSubscriptionResultFragment>){
    return useSubscription<GlobalProviderDashboardWarningNotifierSubscriptionResultFragment>(GlobalProviderDashboardWarningNotifierSubscriptionDocument, opts)
}